import React, { useEffect } from "react";
import { Card, Stack, Typography } from "@curves/ui-base";
import { inBodyInterviewMeasureItems } from "@icoach/inbody/interview/InBodyInterviewMeasureNormalBox";
import { isEmpty } from "@util/utils";
import { MeasureCompareTable } from "@icoach/inbody/components";

const InBodyInterviewMeasureCompareTable = React.forwardRef(({ sourceData: validMeasureData = [], getInterviewMeasureApi }, ref) => {
	useEffect(
		() => {
			getInterviewMeasureApi();
		},
		// eslint-disable-next-line
		[]
	);
	
	return (
		<Card>
			{!isEmpty(validMeasureData) && validMeasureData.length > 1 ? (
				<Card.CardContent>
					<MeasureCompareTable sourceData={validMeasureData} measureItems={inBodyInterviewMeasureItems} />
				</Card.CardContent>
			) : (
				<Card.CardContent className={"p-3"}>
					<Stack justifyContent={"center"} alignItems={"center"}>
						{isEmpty(validMeasureData) && (
							<Typography variant="h6" className={"font-color-4"}>
								無相關資料
							</Typography>
						)}
						{validMeasureData.length === 1 && (
							<Typography variant="h6" className={"font-color-4"}>
								量身資料低於 2 筆無法進行比較
							</Typography>
						)}
					</Stack>
				</Card.CardContent>
			)}
		</Card>
	);
});

export default InBodyInterviewMeasureCompareTable;
